'use client'

import IconUser from '@/components/assets/icon_user.svg'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

type ViverseAvatarSize = 'S' | 'M' | 'L' | 'XL'

interface ViverseAvatarProps {
  size?: ViverseAvatarSize
  imageUrl?: string
}

const SIZE = {
  S: 'size-8.5',
  M: 'size-12',
  L: 'size-16',
  XL: 'size-25',
}

export default function ViverseAvatar({ size = 'S', imageUrl = '' }: ViverseAvatarProps) {
  return (
    <Avatar className={cn('bg-vive-primary-40 transition-all', SIZE[size])}>
      <AvatarImage src={imageUrl} alt="world avatar" className="object-cover" />
      <AvatarFallback className="bg-vive-primary-60">
        {!imageUrl ? (
          <IconUser className="bg-vive-primary-60 size-1/2" />
        ) : (
          <Skeleton className="bg-vive-primary-60 size-full" />
        )}
      </AvatarFallback>
    </Avatar>
  )
}
